import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  text: 'Epic Pavers completely transformed our backyard. The travertine pool deck looks incredible, and the crew was professional, clean, and finished on schedule. Highly recommend!',
  author: 'Michael T.',
  location: 'Henderson, NV'
}, {
  id: 2,
  text: 'We had them rip out our old cracked concrete driveway and install pavers. The difference is night and day. The quality of the stone and the precision of the cuts is top-notch.',
  author: 'Sarah L.',
  location: 'Summerlin, Las Vegas'
}, {
  id: 3,
  text: 'One company for turf and pavers made our project so easy. They handled the HOA approvals and delivered exactly what they promised. Our yard is finally usable year-round.',
  author: 'David R.',
  location: 'North Las Vegas'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-20 md:py-28 bg-charcoal text-white overflow-hidden relative" data-id="element-188">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal-soft/50 transform skew-x-12 translate-x-20" data-id="element-189"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-190">
        <div className="text-center mb-16" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-extrabold font-heading mb-4 tracking-tight" data-id="element-192">
            Client Experiences
          </h2>
          <div className="flex justify-center gap-1" data-id="element-193">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-teal text-teal" data-id="element-194" />)}
          </div>
        </div>

        <div className="max-w-4xl mx-auto relative min-h-[250px]" data-id="element-195">
          <AnimatePresence mode="wait" data-id="element-196">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.5
          }} className="absolute inset-0 flex flex-col items-center text-center" data-id="element-197">
              <p className="text-xl md:text-3xl font-medium leading-relaxed mb-8 text-sand" data-id="element-198">
                {`\u201C${testimonials[currentIndex].text}\u201D`}
              </p>
              <div data-id="element-199">
                <p className="font-bold font-heading text-lg" data-id="element-200">
                  {testimonials[currentIndex].author}
                </p>
                <p className="text-teal text-sm uppercase tracking-wider" data-id="element-201">
                  {testimonials[currentIndex].location}
                </p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-3 mt-12" data-id="element-202">
          {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-teal w-8' : 'bg-charcoal-soft hover:bg-sand/50'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-203" />)}
        </div>
      </div>
    </section>;
}